import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Pillars } from "../components/Pillars";

const ServicesHeader = () => (
    <section className="relative pt-36 sm:pt-44 pb-4">
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.04]"
            style={{
                backgroundImage:
                    "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
                backgroundSize: "64px 64px",
            }}
        />
        <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
            <span className="font-mono text-xs tracking-[-0.01em] text-black/60 border border-black/15 rounded-full px-3.5 py-1.5 inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse" />
                OUR SERVICES
            </span>
            <h1
                data-testid="services-headline"
                className="font-mono tracking-[-0.01em] text-black font-semibold leading-[1.05] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-3xl"
            >
                World-class AI, deployed across every corner of your operation.
            </h1>
            <p className="font-body text-base sm:text-lg text-black/70 max-w-2xl mt-6 leading-relaxed">
                Each engine is a tailored, autonomous module — built to remove
                busywork, sharpen decisions, and compound efficiency across your
                business.
            </p>
        </div>
    </section>
);

const ServicesCTA = () => {
    const navigate = useNavigate();
    return (
        <section
            data-testid="services-cta"
            className="relative pb-28 sm:pb-36"
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8">
                <div className="rounded-3xl bg-black text-white px-8 sm:px-14 py-14 sm:py-20 text-center overflow-hidden relative">
                    <h2 className="font-mono tracking-[-0.01em] text-3xl sm:text-4xl font-semibold leading-tight">
                        Ready to put these engines to work?
                    </h2>
                    <p className="font-body text-base sm:text-lg text-white/60 mt-4 max-w-xl mx-auto">
                        Tell us about your operation and we'll map the highest-
                        impact automations for your business.
                    </p>
                    <button
                        data-testid="services-cta-button"
                        onClick={() => navigate("/contact")}
                        className="group mt-9 font-mono text-sm tracking-[-0.01em] bg-neon text-black px-7 py-4 rounded-full inline-flex items-center gap-2.5 hover:bg-white transition-all duration-300 hover:shadow-[0_0_28px_rgba(20,184,166,0.55)]"
                    >
                        CONTACT US
                        <ArrowRight
                            size={16}
                            className="group-hover:translate-x-0.5 transition-transform"
                        />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default function Services() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash;
            const t = setTimeout(() => {
                document
                    .querySelector(id)
                    ?.scrollIntoView({ behavior: "smooth" });
            }, 120);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0 });
    }, [location.hash]);

    return (
        <main data-testid="services-page">
            <ServicesHeader />
            <Pillars />
            <ServicesCTA />
        </main>
    );
}
